export default __webpack_public_path__ + "static/media/Return-Diagram-Dark.d2904ea5.svg";